import { render, staticRenderFns } from "./ContentBlockOEmbed.vue?vue&type=template&id=5043cbe4&"
import script from "./ContentBlockOEmbed.vue?vue&type=script&lang=js&"
export * from "./ContentBlockOEmbed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports